// extracted by mini-css-extract-plugin
module.exports = {"main":"ClausePage_main__vDT4B","container":"ClausePage_container__2kkmK"};